module.exports = __webpack_public_path__ + "static/caraubas-logo-344598937bb057d14a63d1514bc54afa.jpg";